import { Intent, ProgressBar } from "@blueprintjs/core";
import { getKryBase } from "app/utils/api";
import React, { useEffect, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import * as superagent from 'superagent';

export function Demo() {
  const baseLocation = "https://d3cwbmuyryw1.cloudfront.net/Build/";
  //@ts-ignore
  const [unityReady, setUnityReady] = React.useState(false);
  const [trialOver, setTrialOver] = React.useState(false);
  //@ts-ignore
  const [firstRounData, setFirstRoundData] = React.useState(undefined);
  const [gameID, setGameID] = useState("");

  const loaderHash = '6d72aff75c8e5f6101c706f917ff0aae.loader';
  const dataHash = '3a8b6249c292bb84aa2a5bf43cd1114e';
  const frameworkHash = '7c888048e76554e40f47d73ca84a0fdd.framework';
  const codeHash = '17c2134787f39a79da606268118f2875';

  //@ts-ignore
  const { unityProvider, loadingProgression, isLoaded, sendMessage, addEventListener, removeEventListener } = useUnityContext({
    loaderUrl: baseLocation + loaderHash + ".js",
    dataUrl: baseLocation + dataHash + ".data",
    frameworkUrl: baseLocation + frameworkHash + ".js",
    codeUrl: baseLocation + codeHash + ".wasm",
  });

  useEffect(() => {
    if (isLoaded === true) {
      pushFunction("unity_getGender", "female");
      pushFunction("unity_gotLogin", "viKS6vh8IIE5FYaYOZCXEmlXtADsBAbTp7PTne1pSsodeVOL3L;20");

      createGame_second();
    }
  }, [isLoaded])


  const createGame_second = () => {
    /*
    scenario
    uid
    metadata
    isToCreateGame
    */
    superagent.
      get(getKryBase(undefined) + "kry?scenario=scenario_1&uid=20&metadata=demov1&isToCreateGame=true").
      end((error: any, response: any) => {
        const data = {
          'game-id': response.body['game-id'],
          'scenario': 'scenario_1'
        }

        setGameID(data['game-id']);

        pushFunction("unity_onSetupGame", JSON.stringify(data));
        pushFunction("unity_getClassic", "0");

        setTimeout(() => {
          pushFunction("unity_onFristRound", JSON.stringify(response.body));

          setTimeout(() => {
            pushFunction("unity_onResume", "0");
            pushFunction("unity_recievePlan", "Learn vLeader");
            setUnityReady(true);
          }, 2000);
        }, 2000);

        //pushFunction("unity_onResume", "0");

        setFirstRoundData(response.body);
      });
  }

  const pushFunction = (functionName: string, argument: string) => {
    if (argument === "") {
      sendMessage(
        "WebViewBase",
        functionName
      );
    }
    else {
      sendMessage(
        "WebViewBase",
        functionName,
        argument
      );
    }
  }

  const processRoundLambda = (gameID: string, actionString: string, previousRound: number, cb: any) => {
    const href = getKryBase(undefined) + 'kry?gameID=' + gameID + '&round=' + previousRound.toString() + '&scenarioName=scenario_1&action=' + actionString;

    superagent.
      get(href).
      end((error: any, response: any) => {
        try {
          // Test parsing the content
          const responseText = response.text;

          //@ts-ignore
          const responseAsJSON = JSON.parse(responseText);

          cb(response);
        }
        catch (e) {
          window.alert("There was an error processing your round.  Please try restarting the application.  If the error persists please contact support@simulearn.net");
          throw (e);
        }
      });
  }

  const pushToWindowListener = (bundle) => {
    const aspects = bundle.split('#####');

    if (trialOver === false) {
      // Pass these into the window heap
      try {
        // Use some middleware to properlly format the get round call
        if (aspects[0] === 'unity_getRound') {

          // The first csv is actually the round number
          const baseArgument = aspects[1];

          const allSplices = baseArgument.split(',');

          const roundNumber = allSplices[0];

          const actualAction = baseArgument.replace(roundNumber.toString() + ",", "");

          if (parseInt(roundNumber) >= 10) {
            setTrialOver(true);
          }

          //@ts-ignore
          //window.unity_getRound(roundNumber, actualAction);
          processRoundLambda(gameID, actualAction, roundNumber, (data) => {
            //pushFunction("unity_roundData", roundData)
            pushFunction("unity_roundData", data.text)
          });
        }
        else {
          //@ts-ignore
          window[aspects[0]](aspects[1]);
        }
      }
      catch {

      }
    }
  }

  useEffect(() => {
    addEventListener("pushToWindow", pushToWindowListener);
    return () => {
      removeEventListener("pushToWindow", pushToWindowListener);
    };
  }, [gameID, trialOver]);

  const renderLoadingScreen = () => {
    return <div style={{ flexDirection: 'column', width: '100%', height: '100%', backgroundColor: 'rgba(50,50,50)', color: 'white', alignItems: 'center', justifyContent: 'center', alignContent: 'center', display: 'flex' }}>
      <div style={{ fontSize: '100px', marginBottom: '20px' }}>vLeader</div>

      <div style={{ width: '500px' }}><ProgressBar intent={Intent.SUCCESS} value={loadingProgression * 100.0} /></div>
    </div>
  }

  const calculateUnityStyle = () => {
    if (unityReady) {
      return { width: '100%', height: '100%', display: 'flex' };
    } else {
      return { width: '100%', height: '100%', display: 'none' };
    }
  }

  return (
    trialOver ? <span>Trial Over</span> :
      <div style={{ width: '100%', height: '100%', display: 'flex', overflow: 'hidden' }}>
        {unityReady ? <div></div> : renderLoadingScreen()}
        <Unity style={calculateUnityStyle()} className="inner-unity" unityProvider={unityProvider} />
      </div>
  );
}
